(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('SafraDialogController', SafraDialogController);

    SafraDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Safra', 'Propriedade', 'Custosnwfertilizantes', 'Custosnwdefensivos', 'Indicadoresnw', 'Custosnwproducao', 'Custoshabituaisproducao', 'Indicadoreshabituais', 'Custoshabituaisdefensivos', 'Custoshabituaisfertilizantes', 'Cultura', 'Etapa', 'Preplantioplan', 'Preplantio', 'Plantioplan', 'Plantio', 'Colheitaplan', 'Colheita', 'Armazenamentosafraplan', 'Armazenamentosafra', 'Manutencaosafraplan', 'Comercializacaoplan', 'Comercializacao', 'Entregasafracomercplan', 'Entregasafracomerc', 'Logentregaarmazplan', 'Logentregaarmaz', 'Logrecinsumoplan', 'Logrecinsumo', 'Manutencaosafra'];

    function SafraDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Safra, Propriedade, Custosnwfertilizantes, Custosnwdefensivos, Indicadoresnw, Custosnwproducao, Custoshabituaisproducao, Indicadoreshabituais, Custoshabituaisdefensivos, Custoshabituaisfertilizantes, Cultura, Etapa, Preplantioplan, Preplantio, Plantioplan, Plantio, Colheitaplan, Colheita, Armazenamentosafraplan, Armazenamentosafra, Manutencaosafraplan, Comercializacaoplan, Comercializacao, Entregasafracomercplan, Entregasafracomerc, Logentregaarmazplan, Logentregaarmaz, Logrecinsumoplan, Logrecinsumo, Manutencaosafra) {
        var vm = this;

        vm.safra = entity;
        vm.clear = clear;
        vm.save = save;
        vm.propriedades = Propriedade.queryNomesPropriedadeParceiros({
            size: 1000,
            sort: "nomepropriedade,asc"
        });
        vm.custosnwfertilizantes = Custosnwfertilizantes.query();
        vm.custosnwdefensivos = Custosnwdefensivos.query();
        vm.indicadoresnws = Indicadoresnw.query();
        vm.custosnwproducaos = Custosnwproducao.query();
        vm.custoshabituaisproducaos = Custoshabituaisproducao.query();
        vm.indicadoreshabituais = Indicadoreshabituais.query();
        vm.custoshabituaisdefensivos = Custoshabituaisdefensivos.query();
        vm.custoshabituaisfertilizantes = Custoshabituaisfertilizantes.query();
        vm.culturas = Cultura.query({
            size: 1000,
            sort: "nomecultura,asc"
        });
        vm.etapas = Etapa.query();
        vm.preplantioplans = Preplantioplan.query();
        vm.preplantios = Preplantio.query();
        vm.plantioplans = Plantioplan.query();
        vm.plantios = Plantio.query();
        vm.colheitaplans = Colheitaplan.query();
        vm.colheitas = Colheita.query();
        vm.armazenamentosafraplans = Armazenamentosafraplan.query();
        vm.armazenamentosafras = Armazenamentosafra.query();
        vm.manutencaosafraplans = Manutencaosafraplan.query();
        vm.comercializacaoplans = Comercializacaoplan.query();
        vm.comercializacaos = Comercializacao.query();
        vm.entregasafracomercplans = Entregasafracomercplan.query();
        vm.entregasafracomercs = Entregasafracomerc.query();
        vm.logentregaarmazplans = Logentregaarmazplan.query();
        vm.logentregaarmazs = Logentregaarmaz.query();
        vm.logrecinsumoplans = Logrecinsumoplan.query();
        vm.logrecinsumos = Logrecinsumo.query();
        vm.manutencaosafras = Manutencaosafra.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.safra.id !== null) {
                Safra.update(vm.safra, onSaveSuccess, onSaveError);
            } else {
                Safra.save(vm.safra, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:safraUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
